/**
 * This file was auto-generated by scripts/generate-api-types.mjs.
 * Do not make direct changes to the file. Run `pnpm run codegen` instead.
 */

export interface paths {
  "/api/v1/contact-form": {
    delete?: never;
    get?: never;
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post: operations["api_v1_contact_form_create"];
    put?: never;
    trace?: never;
  };
  "/api/v1/export/kml/": {
    delete?: never;
    /** @description Returns a list of all kml files that are associated with a default plan or have at least one tag. */
    get: operations["api_v1_export_kml_list"];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  "/api/v1/feedback-form": {
    delete?: never;
    get?: never;
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post: operations["api_v1_feedback_form_create"];
    put?: never;
    trace?: never;
  };
  "/api/v1/frontend-config": {
    delete?: never;
    /**
     * @description Per-deployment frontend settings, read by the SPA at startup.
     *
     *     ``domain`` is null unless forced by MAPSET_DOMAIN or a review host, so
     *     the SPA keeps resolving brands (incl. bernmobil) from its hostname.
     */
    get: operations["api_v1_frontend_config_retrieve"];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  "/api/v1/icons/": {
    delete?: never;
    get: operations["api_v1_icons_list"];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  "/api/v1/icons/{set_name}/index.html": {
    delete?: never;
    /**
     * @description Render an HTML icon set index page listing every category/icon in an
     *     icon set, with a keyword search box, e.g.
     *     `/api/v1/icons/mui-outlined/index.html`. Icon metadata (icons.json) comes
     *     from the `list_icons` API, but icon images are loaded from the frontend's
     *     static images folder (see `icons.IMAGES_ROOT`), not the backend. Icons
     *     whose image format couldn't be auto-detected fall back to the `?f=` query
     *     param (default `png`). Note: deliberately not named `format` — DRF
     *     reserves that query param for renderer content negotiation and 404s if it
     *     doesn't match a registered renderer.
     */
    get: operations["api_v1_icons_index.html_retrieve"];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  "/api/v1/invitations/{token}/": {
    delete?: never;
    /** @description Public invitation details by token. Invalid tokens: 404 `invitation_invalid`. */
    get: operations["api_v1_invitations_retrieve"];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  "/api/v1/invitations/{token}/accept/": {
    delete?: never;
    get?: never;
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    /**
     * @description Join the invitation's org with the invited role.
     *
     *     The user's email must match the invitation (403 `invitation_email_mismatch`).
     *     Users with another active org get 403 `already_member`. Repeating the
     *     request returns the same membership.
     */
    post: operations["api_v1_invitations_accept_create"];
    put?: never;
    trace?: never;
  };
  "/api/v1/layouts/": {
    delete?: never;
    get: operations["api_v1_layouts_list"];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  "/api/v1/layouts/{org}/{name}/pdf/": {
    delete?: never;
    get: operations["api_v1_layouts_pdf_retrieve"];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  "/api/v1/me": {
    delete?: never;
    /**
     * @description Current user with their orgs, access state, plans, entitlements and usage.
     *
     *     Lists active and deactivated memberships of active orgs.
     */
    get: operations["api_v1_me_retrieve"];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  "/api/v1/meta/health/": {
    delete?: never;
    /** @description Unauthenticated liveness/readiness probe target for CI and k8s. */
    get: operations["api_v1_meta_health_retrieve"];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  "/api/v1/meta/info/": {
    delete?: never;
    get: operations["api_v1_meta_info_list"];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post: operations["api_v1_meta_info_create"];
    put?: never;
    trace?: never;
  };
  "/api/v1/meta/info/{id}/": {
    delete: operations["api_v1_meta_info_destroy"];
    get: operations["api_v1_meta_info_retrieve"];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch: operations["api_v1_meta_info_partial_update"];
    post?: never;
    put: operations["api_v1_meta_info_update"];
    trace?: never;
  };
  "/api/v1/meta/info/default_print/": {
    delete?: never;
    /**
     * @description Redirect to a PDF with the default plan
     *
     *     As for the default endpoint the `provider` and `station`
     *     params have to be set. `validity` defaults to the current time.
     *
     *     When the PDF file does not exist yet or is out of date, a new PDF
     *     is created. This requires the screenshot tool as well as the local
     *     layout catalog.
     *
     *     If no default plan exists, a map with the station identified by query
     *     parameters is used. This requires the Stops API.
     */
    get: operations["api_v1_meta_info_default_print_retrieve"];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  "/api/v1/meta/info/default/": {
    delete?: never;
    /**
     * @description Public endpoint for default plan info
     *
     *     You need to use query parameters to find up to one matching drawing.
     */
    get: operations["api_v1_meta_info_default_retrieve"];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  "/api/v1/meta/kml/": {
    delete?: never;
    get?: never;
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post: operations["api_v1_meta_kml_create"];
    put?: never;
    trace?: never;
  };
  "/api/v1/meta/kml/{uuid}/": {
    delete: operations["api_v1_meta_kml_destroy"];
    get: operations["api_v1_meta_kml_retrieve"];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch: operations["api_v1_meta_kml_partial_update"];
    post?: never;
    put: operations["api_v1_meta_kml_update"];
    trace?: never;
  };
  "/api/v1/meta/tag/": {
    delete?: never;
    get: operations["api_v1_meta_tag_list"];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  "/api/v1/meta/tag/{id}/": {
    delete?: never;
    get: operations["api_v1_meta_tag_retrieve"];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  "/api/v1/organizations": {
    delete?: never;
    get?: never;
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    /**
     * @description Create an org on the Free plan with the current user as admin.
     *
     *     Repeated requests return the org created first (200). Users with another
     *     active membership get 403 `already_member`.
     */
    post: operations["api_v1_organizations_create"];
    put?: never;
    trace?: never;
  };
  "/api/v1/organizations/{organization_slug}/": {
    delete?: never;
    /** @description Org the user is an active member of. Other orgs return 404. */
    get: operations["api_v1_organizations_retrieve"];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  "/api/v1/organizations/{organization_slug}/invitations/": {
    delete?: never;
    /**
     * @description Pending invitations of the org. Admins only, not on SSO orgs.
     *
     *     POST sends the invitation email. Errors: 403 `invitation_pending`,
     *     `already_member`, `plan_limit_reached` (pending invitations count
     *     toward `max_members`), `free_period_expired`. Creation is rate limited.
     */
    get: operations["api_v1_organizations_invitations_list"];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    /**
     * @description Pending invitations of the org. Admins only, not on SSO orgs.
     *
     *     POST sends the invitation email. Errors: 403 `invitation_pending`,
     *     `already_member`, `plan_limit_reached` (pending invitations count
     *     toward `max_members`), `free_period_expired`. Creation is rate limited.
     */
    post: operations["api_v1_organizations_invitations_create"];
    put?: never;
    trace?: never;
  };
  "/api/v1/organizations/{organization_slug}/invitations/{id}/": {
    /** @description Revoke a pending invitation; its link stops working. */
    delete: operations["api_v1_organizations_invitations_destroy"];
    get?: never;
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  "/api/v1/organizations/{organization_slug}/members/": {
    delete?: never;
    /**
     * @description Active and deactivated members of the org. Readable by any active member.
     *
     *     Not available on SSO orgs (403 `managed_by_sso`).
     */
    get: operations["api_v1_organizations_members_list"];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  "/api/v1/organizations/{organization_slug}/members/{user_id}/": {
    /**
     * @description Change a member's role or remove a member. Admins only, not on SSO orgs
     *     (403 `managed_by_sso`).
     *
     *     Demoting or removing the last active admin returns 403 `last_admin`. The
     *     member gets an email when the role changes or when removed.
     *
     *     Removing keeps the membership row with status `removed`, deletes the user's
     *     sessions, soft-deletes their private maps in the org and leaves their
     *     shared maps in the org without owner.
     */
    delete: operations["api_v1_organizations_members_destroy"];
    get?: never;
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    /**
     * @description Change a member's role or remove a member. Admins only, not on SSO orgs
     *     (403 `managed_by_sso`).
     *
     *     Demoting or removing the last active admin returns 403 `last_admin`. The
     *     member gets an email when the role changes or when removed.
     *
     *     Removing keeps the membership row with status `removed`, deletes the user's
     *     sessions, soft-deletes their private maps in the org and leaves their
     *     shared maps in the org without owner.
     */
    patch: operations["api_v1_organizations_members_partial_update"];
    post?: never;
    put?: never;
    trace?: never;
  };
  "/api/v1/plan_editor/kml/{uuid}": {
    delete?: never;
    get: operations["api_v1_plan_editor_kml_retrieve"];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  "/api/v1/userinfo": {
    delete?: never;
    get: operations["api_v1_userinfo_retrieve"];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
}
export type webhooks = Record<string, never>;
export interface components {
  headers: never;
  parameters: never;
  pathItems: never;
  requestBodies: never;
  responses: never;
  schemas: {
    /**
     * @description * `geops_sso` - geops_sso
     *     * `keycloak` - keycloak
     * @enum {string}
     */
    AuthProviderEnum: "geops_sso" | "keycloak";
    BaseConfig: {
      readonly is_managed_by_sso: boolean;
      /** Format: date-time */
      readonly modified_at: string;
      readonly settings: unknown;
      readonly slug: string;
      readonly title: string;
    };
    /**
     * @description * `Bahnersatzplan` - Bahnersatzplan
     * @enum {string}
     */
    CategoryEnum: "Bahnersatzplan";
    DrawingInfo: {
      config: string;
      default_for?: components["schemas"]["RelatedDefaultPlan"] | null;
      /** Format: date-time */
      readonly deleted_at: null | string;
      readonly id: number;
      name?: string;
      org_editable?: boolean;
      org_visible?: boolean;
      organization?: null | string;
      readonly permissions: {
        can_delete?: boolean;
        can_edit?: boolean;
        can_manage_sharing?: boolean;
      };
      tags?: components["schemas"]["TenantTag"][];
      /**
       * Email address
       * Format: email
       */
      readonly user: string;
      /** Format: uuid */
      uuid: string;
    };
    FeedbackFormRequest: {
      email?: string;
      message?: string;
      title?: string;
      url?: string;
    };
    FrontendConfig: {
      anonymousUserToken: null | string;
      domain: null | string;
      env: null | string;
      vectorTilesUrl: null | string;
    };
    /**
     * @description Documents an icon within `IconCategorySerializer.icons` (see
     *     `icons.get_icon_categories`); not used to actually (de)serialize data.
     */
    Icon: {
      format: null | string;
      id: string;
      keywords?: string[];
      staticImagesFolder: string;
    };
    /**
     * @description Documents an item of the `list_icons` API response (see
     *     `icons.get_icon_categories`); not used to actually (de)serialize data.
     */
    IconCategory: {
      icons: components["schemas"]["Icon"][];
      id: string;
      translations?: {
        [key: string]: string;
      };
    };
    /**
     * @description * `administration` - administration
     *     * `planning` - planning
     *     * `construction` - construction
     *     * `events` - events
     *     * `tourism` - tourism
     *     * `ngo` - ngo
     *     * `education` - education
     *     * `emergency` - emergency
     *     * `media` - media
     *     * `transport` - transport
     *     * `other` - other
     * @enum {string}
     */
    IndustryEnum:
      | "administration"
      | "construction"
      | "education"
      | "emergency"
      | "events"
      | "media"
      | "ngo"
      | "other"
      | "planning"
      | "tourism"
      | "transport";
    /**
     * @description * `month` - month
     *     * `year` - year
     * @enum {string}
     */
    IntervalEnum: "month" | "year";
    /** @description Pending invitation, for the members page. */
    Invitation: {
      /** Format: date-time */
      readonly created_at: string;
      /** Format: email */
      email: string;
      readonly id: number;
      role?: components["schemas"]["RoleEnum"];
      readonly status: components["schemas"]["InvitationStatusEnum"];
    };
    /** @description Invitation looked up by token, for the invite landing page. */
    InvitationPublic: {
      readonly account_exists: boolean;
      /** Format: email */
      readonly email: string;
      readonly invited_by: string;
      readonly organization: string;
      readonly role: components["schemas"]["RoleEnum"];
    };
    /**
     * @description * `pending` - Pending
     *     * `accepted` - Accepted
     *     * `revoked` - Revoked
     * @enum {string}
     */
    InvitationStatusEnum: "accepted" | "pending" | "revoked";
    KMLFile: {
      readonly admin_id: string;
      /** Format: date-time */
      readonly created_at: string;
      data: string;
      /** Format: date-time */
      readonly modified_at: string;
      queryparams: string;
      /** Format: uuid */
      readonly read_id: string;
    };
    KMLFileInfo: {
      data: string;
      max_zoom?: null | number;
      min_zoom?: null | number;
      /** Format: uuid */
      read_id: string;
      readonly revision: string;
    };
    /**
     * @description * `de` - de
     *     * `fr` - fr
     *     * `it` - it
     *     * `en` - en
     * @enum {string}
     */
    LanguageEnum: "de" | "en" | "fr" | "it";
    LayoutMetadata: {
      descriptionLabels: {
        [key: string]: string;
      };
      descriptionValues: {
        [key: string]: string;
      };
      mapBleed: number;
      mapHeight: number;
      mapQrCode: boolean;
      mapWidth: number;
      name: string;
      names: {
        [key: string]: string;
      };
      org: string;
      orientation: string;
      qrCode: boolean;
      titleLabels: {
        [key: string]: string;
      };
      titleValues: {
        [key: string]: string;
      };
      uri: string;
    };
    Me: {
      readonly auth_provider: components["schemas"]["AuthProviderEnum"];
      /**
       * Email address
       * Format: email
       */
      readonly email: string;
      readonly first_name: string;
      readonly flags: {
        ODOO_SYNC_ENABLED: boolean;
        REGISTRATION_ENABLED: boolean;
        UPGRADE_ENABLED: boolean;
      };
      /**
       * Staff status
       * @description Designates whether the user can log into this admin site.
       */
      readonly is_staff: boolean;
      readonly last_name: string;
      readonly organizations: components["schemas"]["MeMembership"][];
      readonly pending_invitation:
        | components["schemas"]["MePendingInvitation"]
        | null;
      readonly state: components["schemas"]["StateEnum"];
    };
    /** @description Member of an org, for the members page. */
    Member: {
      readonly email: string;
      readonly first_name: string;
      readonly id: number;
      readonly last_name: string;
      role?: components["schemas"]["RoleEnum"];
      readonly status: components["schemas"]["StatusEnum"];
    };
    Membership: {
      readonly available_configs: components["schemas"]["BaseConfig"][];
      readonly feature_flags: string[];
      readonly industry: string;
      readonly role: components["schemas"]["RoleEnum"];
      readonly slug: string;
      readonly title: string;
    };
    MeMembership: {
      readonly organization: components["schemas"]["OrganizationPlan"];
      readonly role: components["schemas"]["RoleEnum"];
      readonly status: components["schemas"]["StatusEnum"];
    };
    MePendingInvitation: {
      readonly invited_by: string;
      readonly organization: string;
      readonly role: components["schemas"]["RoleEnum"];
      readonly token: string;
    };
    /**
     * @description * `editor` - editor
     *     * `upgrade` - upgrade
     * @enum {string}
     */
    NextEnum: "editor" | "upgrade";
    /** @enum {unknown} */
    NullEnum: null;
    /** @description Org with its plan, free period, entitlements and usage. */
    OrganizationPlan: {
      readonly entitlements: {
        [key: string]: unknown;
      };
      /** Format: date-time */
      readonly free_period_end: null | string;
      readonly free_period_expired: boolean;
      readonly industry: string;
      readonly plan: string;
      readonly plan_source: components["schemas"]["PlanSourceEnum"];
      readonly slug: string;
      readonly title: string;
      readonly usage: {
        maps: number;
        members: number;
      };
    };
    /** @description Wizard input for creating an org. */
    OrganizationRegistration: {
      /** @description ISO 3166-1 alpha-2 code or `OTHER`. */
      country: string;
      industry: components["schemas"]["IndustryEnum"];
      interval?: components["schemas"]["IntervalEnum"];
      language: components["schemas"]["LanguageEnum"];
      /** @default free */
      plan: components["schemas"]["PlanEnum"];
      terms_accepted: boolean;
      /** @default  */
      title: string;
    };
    OrganizationRegistrationResult: {
      readonly interval:
        | (
            | components["schemas"]["IntervalEnum"]
            | components["schemas"]["NullEnum"]
          )
        | null;
      /**
       * @description `upgrade`: continue with the paid plan checkout.
       *
       *     * `editor` - editor
       *     * `upgrade` - upgrade
       */
      readonly next: components["schemas"]["NextEnum"];
      readonly organization: components["schemas"]["OrganizationPlan"];
      readonly plan: components["schemas"]["PlanEnum"];
    };
    PaginatedDrawingInfoList: {
      /** @example 123 */
      count: number;
      /**
       * Format: uri
       * @example http://api.example.org/accounts/?offset=400&limit=100
       */
      next?: null | string;
      /**
       * Format: uri
       * @example http://api.example.org/accounts/?offset=200&limit=100
       */
      previous?: null | string;
      results: components["schemas"]["DrawingInfo"][];
    };
    PaginatedKMLFileInfoList: {
      /** @example 123 */
      count: number;
      /**
       * Format: uri
       * @example http://api.example.org/accounts/?offset=400&limit=100
       */
      next?: null | string;
      /**
       * Format: uri
       * @example http://api.example.org/accounts/?offset=200&limit=100
       */
      previous?: null | string;
      results: components["schemas"]["KMLFileInfo"][];
    };
    PaginatedTenantTagList: {
      /** @example 123 */
      count: number;
      /**
       * Format: uri
       * @example http://api.example.org/accounts/?offset=400&limit=100
       */
      next?: null | string;
      /**
       * Format: uri
       * @example http://api.example.org/accounts/?offset=200&limit=100
       */
      previous?: null | string;
      results: components["schemas"]["TenantTag"][];
    };
    PatchedDrawingInfo: {
      config?: string;
      default_for?: components["schemas"]["RelatedDefaultPlan"] | null;
      /** Format: date-time */
      readonly deleted_at?: null | string;
      readonly id?: number;
      name?: string;
      org_editable?: boolean;
      org_visible?: boolean;
      organization?: null | string;
      readonly permissions?: {
        can_delete?: boolean;
        can_edit?: boolean;
        can_manage_sharing?: boolean;
      };
      tags?: components["schemas"]["TenantTag"][];
      /**
       * Email address
       * Format: email
       */
      readonly user?: string;
      /** Format: uuid */
      uuid?: string;
    };
    PatchedKMLFile: {
      readonly admin_id?: string;
      /** Format: date-time */
      readonly created_at?: string;
      data?: string;
      /** Format: date-time */
      readonly modified_at?: string;
      queryparams?: string;
      /** Format: uuid */
      readonly read_id?: string;
    };
    /** @description Member of an org, for the members page. */
    PatchedMember: {
      readonly email?: string;
      readonly first_name?: string;
      readonly id?: number;
      readonly last_name?: string;
      role?: components["schemas"]["RoleEnum"];
      readonly status?: components["schemas"]["StatusEnum"];
    };
    /**
     * @description * `free` - free
     *     * `start` - start
     *     * `pro` - pro
     *     * `business` - business
     * @enum {string}
     */
    PlanEnum: "business" | "free" | "pro" | "start";
    /**
     * @description * `free` - Free
     *     * `paid` - Paid
     *     * `sso` - SSO
     * @enum {string}
     */
    PlanSourceEnum: "free" | "paid" | "sso";
    RelatedDefaultPlan: {
      category?: components["schemas"]["CategoryEnum"];
      provider: string;
      station_identifier: string;
      station_name?: null | string;
      /** Format: date-time */
      valid_from?: null | string;
      /** Format: date-time */
      valid_to?: null | string;
    };
    /**
     * @description * `admin` - Admin
     *     * `editor` - Editor
     *     * `reader` - Reader
     * @enum {string}
     */
    RoleEnum: "admin" | "editor" | "reader";
    /**
     * @description * `ok` - Ok
     *     * `no_organization` - No Organization
     *     * `deactivated` - Deactivated
     *     * `free_period_expired` - Free Period Expired
     * @enum {string}
     */
    StateEnum: "deactivated" | "free_period_expired" | "no_organization" | "ok";
    /**
     * @description * `active` - Active
     *     * `deactivated` - Deactivated
     *     * `removed` - Removed
     * @enum {string}
     */
    StatusEnum: "active" | "deactivated" | "removed";
    TenantTag: {
      name: string;
      organization: string;
    };
    User: {
      readonly default_config: null | string;
      /**
       * Email address
       * Format: email
       */
      readonly email: string;
      /**
       * Staff status
       * @description Designates whether the user can log into this admin site.
       */
      readonly is_staff: boolean;
      readonly matching_default_providers: string[];
      readonly organizations: components["schemas"]["Membership"][];
    };
  };
}
export type AuthProviderEnum = components["schemas"]["AuthProviderEnum"];
export type BaseConfig = components["schemas"]["BaseConfig"];
export type CategoryEnum = components["schemas"]["CategoryEnum"];
export type DrawingInfo = components["schemas"]["DrawingInfo"];
export type FeedbackFormRequest = components["schemas"]["FeedbackFormRequest"];
export type FrontendConfig = components["schemas"]["FrontendConfig"];
export type Icon = components["schemas"]["Icon"];
export type IconCategory = components["schemas"]["IconCategory"];
export type IndustryEnum = components["schemas"]["IndustryEnum"];
export type IntervalEnum = components["schemas"]["IntervalEnum"];
export type Invitation = components["schemas"]["Invitation"];
export type InvitationPublic = components["schemas"]["InvitationPublic"];
export type InvitationStatusEnum =
  components["schemas"]["InvitationStatusEnum"];
export type KmlFile = components["schemas"]["KMLFile"];
export type KmlFileInfo = components["schemas"]["KMLFileInfo"];
export type LanguageEnum = components["schemas"]["LanguageEnum"];
export type LayoutMetadata = components["schemas"]["LayoutMetadata"];
export type Me = components["schemas"]["Me"];
export type MeMembership = components["schemas"]["MeMembership"];
export type MePendingInvitation = components["schemas"]["MePendingInvitation"];
export type Member = components["schemas"]["Member"];
export type Membership = components["schemas"]["Membership"];
export type NextEnum = components["schemas"]["NextEnum"];
export type NullEnum = components["schemas"]["NullEnum"];
export type OrganizationPlan = components["schemas"]["OrganizationPlan"];
export type OrganizationRegistration =
  components["schemas"]["OrganizationRegistration"];
export type OrganizationRegistrationResult =
  components["schemas"]["OrganizationRegistrationResult"];
export type PaginatedDrawingInfoList =
  components["schemas"]["PaginatedDrawingInfoList"];
export type PaginatedKmlFileInfoList =
  components["schemas"]["PaginatedKMLFileInfoList"];
export type PaginatedTenantTagList =
  components["schemas"]["PaginatedTenantTagList"];
export type PatchedDrawingInfo = components["schemas"]["PatchedDrawingInfo"];
export type PatchedKmlFile = components["schemas"]["PatchedKMLFile"];
export type PatchedMember = components["schemas"]["PatchedMember"];
export type PlanEnum = components["schemas"]["PlanEnum"];
export type PlanSourceEnum = components["schemas"]["PlanSourceEnum"];
export type RelatedDefaultPlan = components["schemas"]["RelatedDefaultPlan"];
export type RoleEnum = components["schemas"]["RoleEnum"];
export type StateEnum = components["schemas"]["StateEnum"];
export type StatusEnum = components["schemas"]["StatusEnum"];
export type TenantTag = components["schemas"]["TenantTag"];
export type User = components["schemas"]["User"];
export type $defs = Record<string, never>;
export interface operations {
  api_v1_contact_form_create: {
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    requestBody?: {
      content: {
        "application/json": {
          [key: string]: unknown;
        };
        "application/x-www-form-urlencoded": {
          [key: string]: unknown;
        };
        "multipart/form-data": {
          [key: string]: unknown;
        };
      };
    };
    responses: {
      /** @description No response body */
      200: {
        content?: never;
        headers: {
          [name: string]: unknown;
        };
      };
      500: {
        content: {
          "application/json": string;
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  api_v1_export_kml_list: {
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query: {
        /** @description Bounding box */
        bbox: string;
        /**
         * @description Return only default plans. If false, tags must not be empty.
         *
         *     * `False` - False
         *     * `false` - False
         *     * `0` - False
         *     * `True` - True
         *     * `true` - True
         *     * `1` - True
         */
        defaultplans: "0" | "1" | "False" | "false" | "True" | "true";
        /** @description Number of results to return per page. */
        limit?: number;
        /** @description The initial index from which to return the results. */
        offset?: number;
        /** @description Which field to use when ordering the results. */
        ordering?: string;
        /** @description A search term. */
        search?: string;
        tags?: string[];
        /** @description Multiple values may be separated by commas. */
        tenants: string[];
        /** @description Default plan valid at exact time */
        timestamp?: string;
        /** @description Zoom level */
        zoom?: number;
      };
    };
    requestBody?: never;
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["PaginatedKMLFileInfoList"];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  api_v1_feedback_form_create: {
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    requestBody?: {
      content: {
        "application/json": components["schemas"]["FeedbackFormRequest"];
        "application/x-www-form-urlencoded": components["schemas"]["FeedbackFormRequest"];
        "multipart/form-data": {
          email?: string;
          files?: string[];
          message?: string;
          title?: string;
          url?: string;
        };
      };
    };
    responses: {
      /** @description No response body */
      200: {
        content?: never;
        headers: {
          [name: string]: unknown;
        };
      };
      500: {
        content: {
          "application/json": string;
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  api_v1_frontend_config_retrieve: {
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    requestBody?: never;
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["FrontendConfig"];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  "api_v1_icons_index.html_retrieve": {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        set_name: string;
      };
      query?: {
        f?: string;
      };
    };
    requestBody?: never;
    responses: {
      200: {
        content: {
          "text/html": string;
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  api_v1_icons_list: {
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    requestBody?: never;
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["IconCategory"][];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  api_v1_invitations_accept_create: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        token: string;
      };
      query?: never;
    };
    requestBody?: never;
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["MeMembership"];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  api_v1_invitations_retrieve: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        token: string;
      };
      query?: never;
    };
    requestBody?: never;
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["InvitationPublic"];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  api_v1_layouts_list: {
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    requestBody?: never;
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["LayoutMetadata"][];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  api_v1_layouts_pdf_retrieve: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        name: string;
        org: string;
      };
      query?: {
        MAPSET_LAYOUT_DESCRIPTION?: string;
        MAPSET_LAYOUT_MAP?: string;
        MAPSET_LAYOUT_MAP_HEIGHT?: number;
        MAPSET_LAYOUT_MAP_SCALE?: number;
        MAPSET_LAYOUT_MAP_WIDTH?: number;
        MAPSET_LAYOUT_TITLE?: string;
      };
    };
    requestBody?: never;
    responses: {
      200: {
        content: {
          "application/pdf": string;
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  api_v1_me_retrieve: {
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    requestBody?: never;
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["Me"];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  api_v1_meta_health_retrieve: {
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    requestBody?: never;
    responses: {
      /** @description No response body */
      200: {
        content?: never;
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  api_v1_meta_info_create: {
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["DrawingInfo"];
        "application/x-www-form-urlencoded": components["schemas"]["DrawingInfo"];
        "multipart/form-data": components["schemas"]["DrawingInfo"];
      };
    };
    responses: {
      201: {
        content: {
          "application/json": components["schemas"]["DrawingInfo"];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  api_v1_meta_info_default_print_retrieve: {
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query: {
        provider: string;
        station: string;
      };
    };
    requestBody?: never;
    responses: {
      /** @description Redirect to the default plan PDF. */
      302: {
        content?: never;
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  api_v1_meta_info_default_retrieve: {
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: {
        format?: "json" | "kml";
      };
    };
    requestBody?: never;
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["KMLFile"];
          "application/vnd.google-earth.kml+xml": components["schemas"]["KMLFile"];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  api_v1_meta_info_destroy: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /** @description A unique integer value identifying this drawing info. */
        id: number;
      };
      query?: never;
    };
    requestBody?: never;
    responses: {
      /** @description No response body */
      204: {
        content?: never;
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  api_v1_meta_info_list: {
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: {
        /** @description Valid at day */
        day?: string;
        /** @description Has name */
        has_name?: boolean;
        /** @description Number of results to return per page. */
        limit?: number;
        /** @description The initial index from which to return the results. */
        offset?: number;
        /** @description Which field to use when ordering the results. */
        ordering?: string;
        /** @description Organization */
        organization?: string;
        /** @description Provider */
        provider?: string;
        /** @description A search term. */
        search?: string;
        /** @description Station identifier */
        station?: string;
        /** @description Station name */
        station_name?: null | string;
        tag_name?: string[];
        /** @description KML-ID (uuid) */
        uuid?: string;
        /** @description Valid before/after */
        valid_after?: string;
        /** @description Valid before/after */
        valid_before?: string;
        /** @description Valid at exact time */
        validity?: string;
      };
    };
    requestBody?: never;
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["PaginatedDrawingInfoList"];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  api_v1_meta_info_partial_update: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /** @description A unique integer value identifying this drawing info. */
        id: number;
      };
      query?: never;
    };
    requestBody?: {
      content: {
        "application/json": components["schemas"]["PatchedDrawingInfo"];
        "application/x-www-form-urlencoded": components["schemas"]["PatchedDrawingInfo"];
        "multipart/form-data": components["schemas"]["PatchedDrawingInfo"];
      };
    };
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["DrawingInfo"];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  api_v1_meta_info_retrieve: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /** @description A unique integer value identifying this drawing info. */
        id: number;
      };
      query?: never;
    };
    requestBody?: never;
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["DrawingInfo"];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  api_v1_meta_info_update: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /** @description A unique integer value identifying this drawing info. */
        id: number;
      };
      query?: never;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["DrawingInfo"];
        "application/x-www-form-urlencoded": components["schemas"]["DrawingInfo"];
        "multipart/form-data": components["schemas"]["DrawingInfo"];
      };
    };
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["DrawingInfo"];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  api_v1_meta_kml_create: {
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: {
        format?: "json" | "kml";
      };
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["KMLFile"];
        "application/x-www-form-urlencoded": components["schemas"]["KMLFile"];
        "multipart/form-data": components["schemas"]["KMLFile"];
      };
    };
    responses: {
      201: {
        content: {
          "application/json": components["schemas"]["KMLFile"];
          "application/vnd.google-earth.kml+xml": components["schemas"]["KMLFile"];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  api_v1_meta_kml_destroy: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        uuid: string;
      };
      query?: {
        format?: "json" | "kml";
      };
    };
    requestBody?: never;
    responses: {
      /** @description No response body */
      204: {
        content?: never;
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  api_v1_meta_kml_partial_update: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        uuid: string;
      };
      query?: {
        format?: "json" | "kml";
      };
    };
    requestBody?: {
      content: {
        "application/json": components["schemas"]["PatchedKMLFile"];
        "application/x-www-form-urlencoded": components["schemas"]["PatchedKMLFile"];
        "multipart/form-data": components["schemas"]["PatchedKMLFile"];
      };
    };
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["KMLFile"];
          "application/vnd.google-earth.kml+xml": components["schemas"]["KMLFile"];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  api_v1_meta_kml_retrieve: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        uuid: string;
      };
      query?: {
        format?: "json" | "kml";
      };
    };
    requestBody?: never;
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["KMLFile"];
          "application/vnd.google-earth.kml+xml": components["schemas"]["KMLFile"];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  api_v1_meta_kml_update: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        uuid: string;
      };
      query?: {
        format?: "json" | "kml";
      };
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["KMLFile"];
        "application/x-www-form-urlencoded": components["schemas"]["KMLFile"];
        "multipart/form-data": components["schemas"]["KMLFile"];
      };
    };
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["KMLFile"];
          "application/vnd.google-earth.kml+xml": components["schemas"]["KMLFile"];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  api_v1_meta_tag_list: {
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query: {
        /** @description Number of results to return per page. */
        limit?: number;
        name?: string;
        /** @description The initial index from which to return the results. */
        offset?: number;
        /** @description Which field to use when ordering the results. */
        ordering?: string;
        organization: string;
        /** @description A search term. */
        search?: string;
      };
    };
    requestBody?: never;
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["PaginatedTenantTagList"];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  api_v1_meta_tag_retrieve: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /** @description A unique integer value identifying this tenant tag. */
        id: number;
      };
      query?: never;
    };
    requestBody?: never;
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["TenantTag"];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  api_v1_organizations_create: {
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["OrganizationRegistration"];
        "application/x-www-form-urlencoded": components["schemas"]["OrganizationRegistration"];
        "multipart/form-data": components["schemas"]["OrganizationRegistration"];
      };
    };
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["OrganizationRegistrationResult"];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      201: {
        content: {
          "application/json": components["schemas"]["OrganizationRegistrationResult"];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  api_v1_organizations_invitations_create: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        organization_slug: string;
      };
      query?: never;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["Invitation"];
        "application/x-www-form-urlencoded": components["schemas"]["Invitation"];
        "multipart/form-data": components["schemas"]["Invitation"];
      };
    };
    responses: {
      201: {
        content: {
          "application/json": components["schemas"]["Invitation"];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  api_v1_organizations_invitations_destroy: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        id: number;
        organization_slug: string;
      };
      query?: never;
    };
    requestBody?: never;
    responses: {
      /** @description No response body */
      204: {
        content?: never;
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  api_v1_organizations_invitations_list: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        organization_slug: string;
      };
      query?: {
        /** @description Which field to use when ordering the results. */
        ordering?: string;
        /** @description A search term. */
        search?: string;
      };
    };
    requestBody?: never;
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["Invitation"][];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  api_v1_organizations_members_destroy: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        organization_slug: string;
        user_id: number;
      };
      query?: never;
    };
    requestBody?: never;
    responses: {
      /** @description No response body */
      204: {
        content?: never;
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  api_v1_organizations_members_list: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        organization_slug: string;
      };
      query?: {
        /** @description Which field to use when ordering the results. */
        ordering?: string;
        /** @description A search term. */
        search?: string;
      };
    };
    requestBody?: never;
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["Member"][];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  api_v1_organizations_members_partial_update: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        organization_slug: string;
        user_id: number;
      };
      query?: never;
    };
    requestBody?: {
      content: {
        "application/json": components["schemas"]["PatchedMember"];
        "application/x-www-form-urlencoded": components["schemas"]["PatchedMember"];
        "multipart/form-data": components["schemas"]["PatchedMember"];
      };
    };
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["Member"];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  api_v1_organizations_retrieve: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        organization_slug: string;
      };
      query?: never;
    };
    requestBody?: never;
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["OrganizationPlan"];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  api_v1_plan_editor_kml_retrieve: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        uuid: string;
      };
      query?: {
        format?: "json" | "kml";
      };
    };
    requestBody?: never;
    responses: {
      200: {
        content: {
          "application/vnd.google-earth.kml+xml": string;
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  api_v1_userinfo_retrieve: {
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    requestBody?: never;
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["User"];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
}

export const AuthProviderEnum = {
  GeopsSso: "geops_sso",
  Keycloak: "keycloak",
} as const;

export const CategoryEnum = {
  Bahnersatzplan: "Bahnersatzplan",
} as const;

export const IndustryEnum = {
  Administration: "administration",
  Construction: "construction",
  Education: "education",
  Emergency: "emergency",
  Events: "events",
  Media: "media",
  Ngo: "ngo",
  Other: "other",
  Planning: "planning",
  Tourism: "tourism",
  Transport: "transport",
} as const;

export const IntervalEnum = {
  Month: "month",
  Year: "year",
} as const;

export const InvitationStatusEnum = {
  Accepted: "accepted",
  Pending: "pending",
  Revoked: "revoked",
} as const;

export const LanguageEnum = {
  De: "de",
  En: "en",
  Fr: "fr",
  It: "it",
} as const;

export const NextEnum = {
  Editor: "editor",
  Upgrade: "upgrade",
} as const;

export const PlanEnum = {
  Business: "business",
  Free: "free",
  Pro: "pro",
  Start: "start",
} as const;

export const PlanSourceEnum = {
  Free: "free",
  Paid: "paid",
  Sso: "sso",
} as const;

export const RoleEnum = {
  Admin: "admin",
  Editor: "editor",
  Reader: "reader",
} as const;

export const StateEnum = {
  Deactivated: "deactivated",
  FreePeriodExpired: "free_period_expired",
  NoOrganization: "no_organization",
  Ok: "ok",
} as const;

export const StatusEnum = {
  Active: "active",
  Deactivated: "deactivated",
  Removed: "removed",
} as const;
